export * from './RestrictedNumber';


// WEBPACK FOOTER //
// ./src/index.ts